"use client";
import React, { useState } from 'react';
import AllNewsFilter from './AllNewsFilter';
import Link from 'next/link';
import rightarrow from './../../../public/icons/rightarrow.svg';
import Image from 'next/image';
import { convertIntoString } from '@/services/constantService';
import { getNewsList } from '@/services/publicService';

const AllNewsContainer = ({ news, pagination }) => {
    const [filterValue, setFilterValue] = useState("All");
    const [filteredNews, setFilteredNews] = useState(Array.isArray(news) ? news : []);
    const [newsPagination, setNewsPagination] = useState(pagination || {});
    const [currentPage, setCurrentPage] = useState(pagination?.current_page || 1);
    const totalPages = newsPagination?.last_page || 1;
    const totalRecords = newsPagination?.total_record ?? newsPagination?.total ?? filteredNews.length;

    const handlePageChange = async (pageNumber) => {
      if (pageNumber < 1 || pageNumber > totalPages) return;
      setCurrentPage(pageNumber);
      await getNewsListFun(pageNumber);
    };

    //Get news Pagination Function
    const getNewsListFun = async (pageNumber) => {
      const newsData = await getNewsList({ page: pageNumber });
      // Support both structured response { data, pagination } and plain arrays
      const newsFromAPI = Array.isArray(newsData?.data)
        ? newsData.data
        : Array.isArray(newsData)
          ? newsData
          : [];
  
      setFilteredNews(newsFromAPI);
  
      if (newsData?.pagination) {
        setNewsPagination(newsData.pagination);
      }
    }

 


  return (
    <section className="explore-news-section-np">
    <div className="container">
      {/* Header */}
      <div className="row explore-news-header-np align-items-center">
        <div className="col-lg-6 col-md-6">
          <div className="explore-news-title-wrapper-np">
            <div className="explore-news-bar-np"></div>
            <h2 className="explore-news-title-np">Explore News</h2>
          </div>
        </div>
        <div className="col-lg-6 col-md-6">
          <div className="explore-news-filter-wrapper-np">
            <AllNewsFilter filterValue={filterValue} setFilterValue={setFilterValue} />
          </div>
        </div>
      </div>

      {/* News Grid */}
      <div className="row explore-news-grid-np">
        {filteredNews.length > 0 ? (
            filteredNews.map((newsData, index) => (
              <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                  <div className="news-card-np">
                    <div className="news-card-image-wrapper-np">
                      <div className="news-card-image-np">
                        <Image
                          src={newsData?.image?.url && typeof newsData.image.url === 'string' && newsData.image.url.trim() ? newsData.image.url : "/icons/hero.png"}
                          alt={newsData?.title || "News image"}
                          width={400}
                          height={200}
                          style={{ objectFit: 'cover' }}
                        />
                      </div>
                    </div>
                    <div className="news-card-content-np">
                      <h3 className="news-card-title-np"><Link href={`/news/${newsData?.slug || ''}`} target='_blank' prefetch={false} style={{textDecoration: 'none', color: '#0C0C0C'}}>{convertIntoString(newsData?.title || '')}</Link></h3>
                      <p className="news-card-description-np">{newsData?.description || ''}</p>
                      <div className="news-card-meta-bp">
                          <Link href={`/author/${newsData?.author?.slug || ''}`} target='_blank' className="news-card-author-bp" style={{textDecoration: 'none', color: '#0C0C0C'}}>{newsData?.author?.name || 'Unknown'}</Link>
                          <span className="news-card-separator-bp">|</span>
                          <span className="news-card-date-bp">{newsData?.created_at || ''}</span>
                        </div>
                      <Link href={'/news/' + (newsData?.slug || '')} target='_blank' className="news-card-button-np" style={{textDecoration: 'none', color: '#0C0C0C'}}>
                        Read More <Image src={rightarrow} alt='rightarrow' />
                      </Link>
                    </div>
                  </div>
                </div>
            ))
        ) : (
              <div className="col-12 text-center py-5">
                      <p>No News found.</p>
              </div>
        )}
          
        
      </div>
      {/* Pagination Controls */}
          {totalRecords > 1 && totalPages > 1 && (
            <div className="row">
              <div className="col-12">
                <div className="pagination-res">
                  <button
                    className="pagination-btn-res"
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                  >
                    &laquo;
                  </button>
                  <button
                    className="pagination-btn-res"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    &#8249;
                  </button>

                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                    <button
                      key={page}
                      className={`pagination-btn-res ${currentPage === page ? 'active-res' : ''}`}
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  ))}

                  <button
                    className="pagination-btn-res"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    &#8250;
                  </button>
                  <button
                    className="pagination-btn-res"
                    onClick={() => handlePageChange(totalPages)}
                    disabled={currentPage === totalPages}
                  >
                    &raquo;
                  </button>
                </div>
              </div>
            </div>
          )}
    </div>
  </section>
  );
};

export default AllNewsContainer;